(function () {
  /* Nutrition panel: servings per container follows the size picked in the buy box. */
  document.addEventListener('bbn:size-change', (event) => {
    const { productId, variantId } = event.detail || {};
    document.querySelectorAll(`.bbn-main-product-main[data-product-id="${productId}"]`).forEach((section) => {
      /* Nutrition label: the variant's own label if it has one, else the product-level label. */
      section.querySelectorAll('[data-nf-panel]').forEach((panel) => {
        const blocks = Array.from(panel.querySelectorAll('[data-nf-variant]'));
        const show =
          blocks.find((el) => el.dataset.nfVariant === String(variantId)) ||
          blocks.find((el) => el.dataset.nfVariant === 'default');
        blocks.forEach((el) => {
          el.hidden = el !== show;
        });
        panel.hidden = !show;
      });

      const data = section.querySelector('script[data-servings]');
      if (!data) return;
      let map = {};
      try {
        map = JSON.parse(data.textContent);
      } catch (error) {
        return;
      }
      const text = map[variantId];
      /* Variant labels carry their own servings line; only the product-level label follows the size. */
      section.querySelectorAll('[data-nf-variant="default"] [data-nf-servings]').forEach((el) => {
        if (text) el.textContent = text;
      });
    });
  });

  /* Photo slider: front of bag, cluster photo, back of bag. Arrows, swipe on touch. */
  const go = (slider, step) => {
    const slides = Array.from(slider.querySelectorAll('.pp-main__img'));
    if (slides.length < 2) return;
    const current = Math.max(0, slides.findIndex((el) => el.classList.contains('is-active')));
    const next = (current + step + slides.length) % slides.length;
    slides.forEach((el, i) => el.classList.toggle('is-active', i === next));
    slider.querySelectorAll('.pp-dots i').forEach((el, i) => el.classList.toggle('is-active', i === next));
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-pp-prev], [data-pp-next]');
    if (!button) return;
    const slider = button.closest('[data-pp-slider]');
    if (slider) go(slider, button.hasAttribute('data-pp-prev') ? -1 : 1);
  });

  let touchX = null;
  let touchY = null;
  document.addEventListener(
    'touchstart',
    (event) => {
      if (!event.target.closest('[data-pp-slider]')) return;
      touchX = event.touches[0].clientX;
      touchY = event.touches[0].clientY;
    },
    { passive: true }
  );
  document.addEventListener(
    'touchend',
    (event) => {
      const slider = event.target.closest('[data-pp-slider]');
      if (!slider || touchX === null) return;
      const dx = event.changedTouches[0].clientX - touchX;
      const dy = event.changedTouches[0].clientY - touchY;
      touchX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(slider, dx < 0 ? 1 : -1);
    },
    { passive: true }
  );
})();
